<template>
  <div class="change-request mb-15" v-if="current && !['done', 'rejected'].includes(current.state)">
    <h5 class="title is-6 mb-5">{{ $t('docflow.changeRequest.title') }}</h5>
    <div class="level mb-5">
      <div class="level-left">
        <span class="small-gray-text">{{ changeRequest.author.initials }}</span>
      </div>
      <div class="level-right">
        <span class="small-gray-text">{{ changeRequest.created_at | localedShortDate }}</span>
      </div>
    </div>
    <div class="note mb-10">{{ changeRequest.note }}</div>
    <div class="control mt-0">
      <template v-if="current.state === 'pending_approve'">
        <div class="button is-success is-small mr-10" @click="approve">{{ $t('interface.accept') }}</div>
        <div class="button is-danger is-small mr-10" @click="reject">{{ $t('interface.reject') }}</div>
      </template>
      <div class="button is-success is-small"
           @click="done"
           v-if="current.state === 'approved'">
        {{ $t('interface.apply') }}
      </div>
    </div>
    <NotePrompt ref="notePrompt"/>
  </div>
</template>

<script>
  import NotePrompt from '@/components/NotePrompt'

  export default {
    props: ['data'],
    components: {NotePrompt},
    methods: {
      approve() {
        this.$store.dispatch('Docflow/approveChangeRequest').then(this.update)
      },
      reject() {
        this.$refs.notePrompt.open({
          onConfirm: note => this.$store.dispatch('Docflow/rejectChangeRequest', note).then(this.update)
        })
      },
      done() {
        this.$store.dispatch('Docflow/doneChangeRequest').then(this.update)
      },
      update() {
        this.$emit('change')
      }
    },
    computed: {
      current() {
        return this.data.length ? this.data[0] : false
      },
      changeRequest() {
        let changeRequests = this.data.filter(state => state.state === 'pending_approve')
        return changeRequests.length ? changeRequests[0] : false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .change-request {

    .small-gray-text {
      font-size: 13px;
      color: #969696;
    }

    a {
      color: #3498db;
      font-size: 13px;

      .icon {
        position: relative;
        left: 2px;
      }
    }

    .note {
      font-size: 14px;
    }
  }
</style>
